import { TranslatePipe } from '../../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import { ItemErrorComponent } from '../../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../../utils/session.service';
import Config from '../../../utils/config.service';
import BusinessRestServices from '../../../services/business-rest.service';
import WordCloudService from '../../../services/word-cloud.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import RoutingService from '../../../services/routing.service';

@Component({
	standalone: true,
	selector: 'pre-visit-mental-check',
	templateUrl: './pre-visit-mental-check.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, ItemErrorComponent, FormsModule ]
})
export default class PreVisitMentalCheckComponent implements OnInit {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private wordCloudService: WordCloudService = inject(WordCloudService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isProcessing = true;
		this.routingService.validateAccess('preVisitDashboard').then(() => {
			var rawData: any = window.sessionStorage.getItem(this.config.getBookingConfig().Instant.STORAGE_KEY);
			var booking: any = rawData ? JSON.parse(rawData) : {};
			var origin: any = this.angularRoutingHelperService.getQueryParam('origin');
			
			if (booking && booking.service) {
				this.loadWordCloud();
			} else {
				var params: any = {
					origin: origin
				};
				this.businessRestServices.getOnDemandSettings(params, (settings) => {
					this.vm.allOndemandSettings = settings;
					this.loadWordCloud();
				});
			}
		});
	}
	
	loadWordCloud() {
		this.wordCloudService.getQuestionnaire().then((questionnaire) => {
			this.vm.questionnaire = questionnaire;
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.isProcessing = false;
		this.vm.user = this.session.getSession().user;
		this.vm.problemMaxLength = 300;
		this.vm.questionnaireId = 0;
		this.vm.question = '';
		this.vm.answers = [];
		this.vm.isInputTextAreaShown = false;
		this.vm.step = this.angularRoutingHelperService.getQueryParams()['step'];
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		this.vm.primaryLanguage = this.vm.user.deviceLanguage.split('_')[0];
		
		this.vm.questionnaireId = this.vm.questionnaire.id;
		this.vm.question = this.vm.questionnaire.questions[0].translation['translationText'];
		this.vm.questionnaire.questions[0]['answers'].map((answer) => {
			if (answer.id && answer.defaultText && answer.translation) {
				this.vm.answers.push({
					id: answer.id,
					defaultText: answer.defaultText,
					text: answer.translation['translationText'],
					isSelected: false
				})
			}
		});
		
		this.vm.settings = this.vm.allOndemandSettings.filter((item) => {
			return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'MENTAL_CHECK';
		})[0] || {};
		
		this.vm.duration = this.vm.settings.timePerPrice;
		
		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.onAnswerClick = this.onAnswerClick;
		
		this.setTitle();
		this.vm.isInitialized = true;
	}
	
	setTitle() {
		this.vm.title = this.vm.question;
	}
	
	onAnswerClick($event, answer) {
		this.vm.answers = this.vm.answers.map((item) => {
			if (item.defaultText === answer.defaultText) {
				item.isSelected = !item.isSelected;
			}
			return item;
		});
		
		var problems: any = (this.vm.answers.filter((item) => {
			return item.isSelected;
		}) || []).map((item) => {
			return item.text;
		});
		if (problems.length === 0) {
			this.vm.nothingSelected = true;
		} else {
			this.vm.nothingSelected = false;
		}
		
		this.vm.isInputTextAreaShown = !!this.vm.answers.find((item) => {
			return ('other' === item.defaultText.toLowerCase()) && item.isSelected;
		});
	}
	
	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		
		var problems: any = (this.vm.answers.filter((item) => {
			return item.isSelected;
		}) || []).map((item) => {
			return item.text;
		});
		
		if (problems.length === 0) {
			this.vm.nothingSelected = true;
		} else {
			this.vm.nothingSelected = false;
		}
		
		if (this.vm.nothingSelected || mainForm.invalid || this.vm.isProcessing) {
			return;
		}
		this.vm.isProcessing = true;
		
		var selectedItemIds: any = this.vm.answers
			.filter((answer) => {
				return answer.isSelected
			})
			.map((answer) => {
				return answer.id
			});
		
		var queryParams = {
			'selectedItem': selectedItemIds,
			'primaryLanguage': this.vm.primaryLanguage,
			'type':'pre-visit'
		};
		
		if (this.vm.problem) {
			queryParams['problem'] = this.vm.problem;
		}
		this.angularRoutingHelperService.setPath('/booking/intermediate-dialog', false, false, queryParams);
	}
	
}